import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import SplashScreen from 'components/SplashScreen';
import authService from 'utils/api';
import { logout, login, refreshAccount } from 'store/accountSlice';

function Auth(props) {
  const { children } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector((state) => state.account);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      authService.setAxiosInterceptors({
        onLogout: () => dispatch(logout()),
      });
      await authService.handleAuthentication().catch((err) => {
        console.log('Erro de autenticação handleAuthentication err');
        history.push('/');
        return err;
      });

      if (authService.isAuthenticated()) {
        await dispatch(login());
        dispatch(refreshAccount());
      }
      setLoading(false);
    };

    initAuth();
  }, [dispatch, history]);

  if (isLoading || loading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any,
};

export default Auth;
